module.exports = {
    SUCCESS: '0',
    CONTRACT_NOT_FOUND: 'OJ0001'
}
